import * as yup from 'yup'

export const getFiltersSchema = () => ({
    from: yup.string().optional().nullable(),
    to: yup.string().optional().nullable(),
    login: yup.string().optional().nullable(),
    status: yup.string().optional().nullable(),
    page: yup.number(),
    limit: yup.number(),
})

export const STATUS_FILTER = {
    ALL: 'All',
    SUCCESS: 'Success',
    FAILURE: 'Failure',
} as const